export enum WindowEvents {
    Resize = "resize",
}
